/**
 * Ayarlar sayfası — backend URL, relay/signaling URL, tema, data reset.
 */
import { appState, resolveDefaultRelayUrl, resolveDefaultSignalUrl } from '../state';
import { applyStyle, escapeHtml } from '../ui/css';
import { createCard } from '../ui/components/card';
import { createButton } from '../ui/components/button';
import { createPageHeader } from '../ui/components/pageHeader';
import { icons } from '../ui/icons';
export function renderSettings() {
    const root = document.createElement('div');
    root.append(createPageHeader({
        title: 'Ayarlar',
        subtitle: 'Bağlantı uçları, görüntü tercihi ve yerel veri yönetimi.',
    }));
    const relay = resolveDefaultRelayUrl();
    const signal = resolveDefaultSignalUrl();
    const theme = localStorage.getItem('photon.theme') ?? 'system';
    const grid = document.createElement('div');
    grid.classList.add('pr-grid-cards');
    applyStyle(grid, {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(360px, 1fr))',
        gap: 'var(--sp-4)',
    });
    // Bağlantı kartı
    const connCard = createCard({
        caption: 'BAĞLANTI',
        title: 'Sunucu uçları',
        subtitle: 'Varsayılanlar host\'tan otomatik türetilir; sadece custom server için değiştir.',
    });
    const connBody = document.createElement('div');
    applyStyle(connBody, { display: 'flex', flexDirection: 'column', gap: 'var(--sp-3)', marginTop: 'var(--sp-3)' });
    connBody.innerHTML = `
    ${urlField('url-backend', 'Backend API URL', appState.backendUrl)}
    ${urlField('url-relay', 'Relay WebSocket URL', relay)}
    ${urlField('url-signal', 'Signaling WebSocket URL', signal)}
  `;
    connCard.append(connBody);
    grid.append(connCard);
    // Görüntü kartı
    const themeCard = createCard({
        caption: 'GÖRÜNTÜ',
        title: 'Tema',
        subtitle: 'Light tema şu an deneysel — lime accent için dark önerilir.',
    });
    const themeBody = document.createElement('div');
    applyStyle(themeBody, { display: 'flex', flexDirection: 'column', gap: 'var(--sp-3)', marginTop: 'var(--sp-3)' });
    themeBody.innerHTML = `
    <label style="display:flex;flex-direction:column;gap:6px;font-size:var(--fs-tiny);letter-spacing:0.12em;color:var(--text-tertiary);font-weight:500">
      TEMA TERCİHİ
      <select id="theme" style="padding:10px 14px;font-size:var(--fs-body);background:var(--bg-elev-3);border:1px solid var(--border-strong);border-radius:var(--radius-sm);color:var(--text-primary)">
        <option value="system" ${theme === 'system' ? 'selected' : ''}>Sistem (varsayılan)</option>
        <option value="dark" ${theme === 'dark' ? 'selected' : ''}>Koyu (önerilen)</option>
        <option value="light" ${theme === 'light' ? 'selected' : ''}>Açık</option>
      </select>
    </label>
  `;
    themeCard.append(themeBody);
    grid.append(themeCard);
    root.append(grid);
    // Aksiyon barı
    const actionRow = document.createElement('div');
    applyStyle(actionRow, {
        display: 'flex',
        gap: 'var(--sp-2)',
        marginTop: 'var(--sp-5)',
        flexWrap: 'wrap',
    });
    const saveBtn = createButton({
        label: 'Kaydet',
        variant: 'primary',
        iconHtml: icons.copy(),
    });
    const resetBtn = createButton({
        label: 'Yerel veriyi sıfırla',
        variant: 'danger',
        iconHtml: icons.trash(),
    });
    actionRow.append(saveBtn, resetBtn);
    root.append(actionRow);
    // Bilgi kartı
    const infoCard = createCard({
        caption: 'BİLGİ',
        title: 'Yerel sıfırlama',
    });
    const infoBody = document.createElement('div');
    applyStyle(infoBody, {
        fontSize: 'var(--fs-caption)',
        color: 'var(--text-secondary)',
        lineHeight: '1.6',
        marginTop: 'var(--sp-2)',
    });
    infoBody.innerHTML = `
    <strong style="color:var(--text-primary)">Sıfırlama silecek:</strong>
    kayıtlı host'lar, backend URL override'ı, tema tercihi, son giriş e-postası.
    <br><br>
    <strong style="color:var(--text-primary)">Etkilenmez:</strong>
    sunucu üzerindeki hesabın, cihaz kayıtların, address-book entries (server-side).
    Tekrar giriş yapınca bunlar geri yüklenir.
  `;
    infoCard.append(infoBody);
    applyStyle(infoCard, { marginTop: 'var(--sp-5)' });
    root.append(infoCard);
    // Davranış
    saveBtn.addEventListener('click', () => {
        appState.setBackendUrl(root.querySelector('#url-backend').value.trim());
        localStorage.setItem('photon.relayUrl', root.querySelector('#url-relay').value.trim());
        localStorage.setItem('photon.signalUrl', root.querySelector('#url-signal').value.trim());
        localStorage.setItem('photon.theme', root.querySelector('#theme').value);
        flashSaved(saveBtn);
    });
    resetBtn.addEventListener('click', () => {
        if (!confirm('Tüm yerel veri silinsin? (kayıtlı host\'lar dahil)'))
            return;
        Object.keys(localStorage).filter(k => k.startsWith('photon.'))
            .forEach(k => localStorage.removeItem(k));
        alert('✓ Sıfırlandı. Sayfayı yenile.');
    });
    return root;
}
function urlField(id, label, value) {
    return `
    <label style="display:flex;flex-direction:column;gap:6px;font-size:var(--fs-tiny);letter-spacing:0.12em;color:var(--text-tertiary);font-weight:500">
      ${escapeHtml(label.toUpperCase())}
      <input id="${id}" type="url" value="${escapeHtml(value)}"
             style="padding:10px 14px;font-size:var(--fs-caption);font-family:var(--font-mono);background:var(--bg-elev-3);border:1px solid var(--border-strong);border-radius:var(--radius-sm);color:var(--text-primary)" />
    </label>
  `;
}
function flashSaved(btn) {
    const span = btn.querySelector('span');
    if (!span)
        return;
    const orig = span.textContent;
    span.textContent = '✓ Kaydedildi';
    setTimeout(() => { span.textContent = orig ?? 'Kaydet'; }, 1800);
}
